import { getImpersonationToken, clearImpersonationToken } from 'src/utils'
import { appActions } from 'src/store/app'

let store = null

// Inject Redux store
export const injectStore = (_store) => {
  store = _store
}

export const setupErrorInterceptor = (client) => {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && getImpersonationToken()) {
        clearImpersonationToken()
        store?.dispatch(appActions.setImpersonationTokenHandler(null))
      }
      return Promise.reject(error)
    },
  )
}
